import React from "react";
import { colors2 } from "oolib";
import { UI_CAPTION_DF } from "oolib/dist/v2/components/Typo2";
import { ArrowRight } from "@phosphor-icons/react";

/**
 * A share moving between two points in time — "2.5% → 6.4%". The earlier
 * share reads grey and the current one dark, the same emphasis the period
 * count columns beside it use, so a row's before and after can be told
 * apart at a glance without reading the numbers.
 *
 * Per row (dynamicPropsCallback): `from`, `to` (percentages already on a
 * 0–100 scale), `decimals`, `hint`. `value` is ignored — point `valuePath`
 * at a string field that is null when there is nothing to show, so the
 * cell falls back to "–" rather than rendering a half-pair.
 */
const TableShareShift = ({ from, to, decimals = 1, hint }) => {
  if (typeof from !== "number" || typeof to !== "number") return null;
  const pct = (n) => `${n.toFixed(decimals)}%`;
  return (
    <span
      title={hint || undefined}
      style={{ display: "inline-flex", alignItems: "center", gap: "0.3rem", whiteSpace: "nowrap" }}
    >
      <UI_CAPTION_DF style={{ color: colors2.grey50, fontVariantNumeric: "tabular-nums" }}>{pct(from)}</UI_CAPTION_DF>
      <ArrowRight size={11} weight="bold" color={colors2.grey30} />
      <UI_CAPTION_DF style={{ color: colors2.grey80, fontWeight: 600, fontVariantNumeric: "tabular-nums" }}>
        {pct(to)}
      </UI_CAPTION_DF>
    </span>
  );
};

export default TableShareShift;
